<template>
  <div id="note-container" style="height: calc(100% - 50px);">
    <div class="notepad-widget mt-2" style="height:100%">
        <textarea  v-model="note" placeholder="Type your notes here..."></textarea>
        <p class="expiry-note">Notes are saved in your browser. If you clear your browser data, your notes will be lost.</p>
    </div>
    <div class="mt-2" style="height: 50px;">
      <button class="btn btn-hub-primary" @click="downloadNote">Download Note</button>
      <button class="btn btn-secondary" @click="clearNote">Clear Note</button>
    </div>
  </div>
</template>

<script>
export default {
    data() {
        return {
            note: localStorage.getItem('g2-notepad-note') || ''
        };
    },
    methods: {
        downloadNote() {
            const blob = new Blob([this.note], { type: 'text/plain' });
            const link = document.createElement('a');
            link.href = URL.createObjectURL(blob);
            link.download = 'g2_communicator_note.txt';
            link.click();
        },
        clearNote() {
          this.g2dialog.$confirm('Are you sure you want to clear your note?').then((confirmed) => {
            if (!confirmed) return;
            this.note = '';
          });
        }
    },
    watch: {
        note: {
            handler: function (newValue) {
                localStorage.setItem('g2-notepad-note', newValue);
            },
            deep: true
        }
    }
}
</script>

<style scoped>
.notepad-widget {
    display: flex;
    flex-direction: column;
    height: 100%;
    padding: 10px;
}

textarea {
    flex-grow: 1;
    margin-bottom: 10px;
    padding: 5px;
    border: 1px solid #ccc;
    font-size: 16px;
}

.expiry-note {
    font-size: 12px;
    color: #888;
}
</style>